export enum ProfileComponentType {
    RTO = 1,
    PhoneNumber = 2,
    AddressMissing = 3,
    Address = 4,
    WorkHistory = 5,
    WorkHistoryAndEducation = 6,
    Education = 7,
    LicenseMatch = 8,
    LicenseMissing = 9,
    References = 10,
    SkillsAssessment = 11,
    CertificationMissing = 12,
    CandidateAddress = 13,
    CandidatePhoneNumber = 14
}
